import {
  usePlatformApiUrlQuery,
  useSolverApiUrlQuery,
} from '@innovamat/glow-api-client';
import { useEffect } from 'react';
import { useUnityDataStore } from '../store/unity-data';

function useUrls() {
  const { data: solverQuery } = useSolverApiUrlQuery();
  const solverUrl = solverQuery?.solverApiUrl;
  const { data: platformQuery } = usePlatformApiUrlQuery();
  const platformUrl = platformQuery?.platformApiUrl;
  const { updatePlatformUrl, updateSolverUrl } = useUnityDataStore();

  useEffect(() => {
    if (platformUrl) {
      updatePlatformUrl(platformUrl);
    }
    if (solverUrl) {
      updateSolverUrl(solverUrl);
    }
  }, [platformUrl, solverUrl]);
}

export { useUrls };
